import "./contact.css";
import Whatsapp from "../assets/wapp.svg";

export function Contact() {
  const handleWhatsAppClick = () => {
  const url = 'https://api.whatsapp.com/send?phone=5492257550272';

  if (window.gtag) {
    let opened = false;

    window.gtag('event', 'conversion', {
      send_to: 'AW-18098794923/5EEFCIuPsKUcEKvjlrZD',
      event_callback: () => {
        if (!opened) {
          opened = true;
          window.open(url, '_blank');
        }
      }
    });

    setTimeout(() => {
      if (!opened) {
        opened = true;
        window.open(url, '_blank');
      }
    }, 800);

  } else {
    window.open(url, '_blank');
  }
};
  return (
    <section id="contact" className="section alt">
      <div className="container">
        <h3>Contacto</h3>
        <div className="contact-info">
          <p>📞 Teléfono: (2257) 550272</p>
          <p>
            📍 Zona: Partido de la Costa
            <br />
          </p>
          <p className="locations">
            (San Clemente, Las Toninas, Santa Teresita, Mar del Tuyú, Costa del Este,
            Aguas Verdes, La Lucila, Costa Azul, San Bernardo, Mar de Ajó, Nueva Atlantis, Pinamar)
          </p>
          <button
          onClick={handleWhatsAppClick}
          className="btn-primary"
        >
          <img src={Whatsapp} alt="WhatsApp" className="whatsapp-icon" />
          Contactar por WhatsApp
        </button>
        </div>
      </div>
    </section>
  );
}